import * as React from 'react';
import styled from 'styled-components';

export const OpenGalleryButton: React.FC<{ onClick: () => void }> = ({
  onClick,
}) => {
  return (
    <StyledOpenGalleryButton
      aria-label="åpne galleri"
      name="open-gallery"
      onClick={onClick}
    >
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="36" cy="36" r="35" stroke="black" strokeWidth="2" />
        <path d="M29 18L47 36L29 54" stroke="black" strokeWidth="2" />
      </svg>
    </StyledOpenGalleryButton>
  );
};

const StyledOpenGalleryButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  border: none;
  outline: none;
  appearance: none;
  background: none;

  svg {
    circle {
      stroke: ${({ theme }) => theme.top.play};
    }
    path {
      stroke: ${({ theme }) => theme.top.play};
    }
  }

  &:hover {
    cursor: pointer;
  }
`;
